import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { HeaderButton } from "../../common/header/HeaderButton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LastSavedIndicator } from "./LastSavedIndicator";

interface Props {
  showMetadata: boolean;
  onToggleMetadata: () => void;
  updatedAt?: string | null;
}

export function ItemHeader({
  showMetadata,
  onToggleMetadata,
  updatedAt,
}: Props) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  return (
    <Row className="gy-2 py-2">
      <Col className="col-auto d-flex">
        <div className="d-flex with-left-column">
          <HeaderButton icon={faArrowLeft} onClick={() => navigate(-1)} />
        </div>
      </Col>
      <Col className="d-flex col-8 col-md align-items-center">
        <div className="d-flex flex-column">
          <h3 className="mb-0 ps-0">{t("items.edit.title")}</h3>
          <LastSavedIndicator updatedAt={updatedAt} />
        </div>
      </Col>
      <Col className="col-auto order-2 order-md-3 d-flex justify-content-end ">
        <Button
          color="primary"
          active={showMetadata}
          onClick={onToggleMetadata}
        >
          <FontAwesomeIcon icon={faClockRotateLeft} className="pe-2" />
          {t("items.edit.info")}
        </Button>
      </Col>
    </Row>
  );
}
